export default __webpack_public_path__ + "static/media/comfortline.4a260d2a.webp";